<template>
    <div class="app-header">
        <div class="navbar navbar-toggleable-sm flex-row align-items-center">
            <!-- Open side - Naviation on mobile -->
            <a data-toggle="modal"
               data-target="#aside"
               class="d-lg-none mr-3 mt-1 position-absolute">
                <i class="material-icons">&#xe5d2;</i>
            </a>
            <!-- / -->
            <div class="d-flex flex-row justify-content-between w-100 ml-4">
                <div class="d-flex flex-column justify-content-center">
                    <div class="d-flex flex-row">
                        <a class="d-none d-lg-block mr-3 text-lg text-blackish"
                           v-if="!profile.is_reseller"
                           @click.prevent="toggleSidebar"
                           :title="sidebar_folded ? 'Normal Layout' : 'Expanded Layout'">
                            <i class="fa fa-bars"></i>
                        </a>
                        <!-- Page title - Bind to $state's title -->
                        <div class="mb-0"
                             id="page-title">
                            {{ pageTitle }}
                        </div>
                    </div>
                </div>

                <!-- navbar collapse -->
                <div class="collapse navbar-collapse"
                     id="collapse">
                </div>
                <!-- / navbar collapse -->

                <div v-if="auth.user.profile"
                     class="d-flex flex-column justify-content-center">
                    <b class="text-title d-none d-sm-block"
                       v-if="!auth.user.profile.is_reseller">Alo Super Admin</b>
                    <b class="text-title d-none d-sm-block"
                       v-if="auth.user.profile.is_reseller && auth.user.profile.reseller">
                        {{ auth.user.profile.reseller.name }} Partner Portal
                    </b>
                </div>

                <!-- navbar right -->
                <ul class="nav navbar-nav flex-row no-select">
                    <li class="nav-item dropdown mr-2 bg-dark">
                        <a class="nav-link dropdown-toggle text-ellipsis text-white"
                           data-toggle="dropdown"
                           data-flip="false"
                           data-tour-step="3"
                           ref="mainMenu">
                            <div class="profile-info d-flex align-items-center pl-1"
                                 v-if="auth.user.profile">
                                <div class="d-flex flex-column ml-2"
                                     style="line-height: 1.2rem;">
                                    <template v-if="auth.user.profile.is_reseller">
                                        <small class="dropdown-label text-white">
                                            {{ auth.user.profile.first_name }} {{ auth.user.profile.last_name }}
                                        </small>
                                        <span class="company-name _600 text-white"
                                              v-if="auth.user.profile.is_reseller">
                                            {{ auth.user.profile.reseller.name }}
                                        </span>
                                    </template>
                                    <template v-if="!auth.user.profile.is_reseller">
                                        <small class="dropdown-label text-white">
                                            {{ auth.user.profile.name }}
                                        </small>
                                        <span class="company-name _600 text-white" >
                                            {{ auth.user.profile.email }}
                                        </span>
                                    </template>
                                </div>
                                <i class="material-icons ml-2">keyboard_arrow_down</i>
                            </div>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right dropdown-menu-overlay dropdown-menu-scale pull-right">
                            <div class="row">
                                <div class="col-12">
                                    <router-link :to="{ name: 'Profile'}"
                                                 class="dropdown-item">
                                        <i class="material-icons">person</i>
                                        Profile
                                    </router-link>
                                </div>
                            </div>
                            <div class="row"
                                 @click="noClose($event)">
                                <div class="col-12">
                                    <a class="dropdown-item text-danger"
                                       @click="logout">
                                        <i class="material-icons">power_settings_new</i>
                                        Sign Out
                                    </a>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- / navbar right -->
            </div>
        </div>
    </div>
</template>

<script>
    import auth from '../auth'
    import {mapActions, mapState} from 'vuex'

    export default {

        data() {
            return {
                auth: auth,
                profile: auth.user.profile,
                pageTitle: '',
            }
        },

        computed: {
            ...mapState({
                sidebar_folded: state => state.cache.sidebar_folded
            })
        },

        watch: {
            '$route.name': function (name) {
                this.pageTitle = name.capitalize()
            }
        },

        methods: {
            noClose(event) {
                if (event) {
                    event.stopPropagation()
                }
            },

            logout() {
                auth.logout()
                    .then(res => {
                        this.response = res.data
                        this.resetCache()
                        window.location.href = '/admin/login'
                    })
                    .catch(err => {
                        this.response = err.response.data.error
                    })
            },

            toggleSidebar() {
                this.setSidebarFolded(!this.sidebar_folded)
                VueEvent.fire('content_resized')
            },

            ...mapActions('cache', ['setSidebarFolded', 'resetCache'])
        }
    }
</script>
